// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Flutt ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Skipun',
  accControlKey: () => 'Loka',
  accPositionAfter: () => 'eftir',
  accPositionBefore: () => 'fyrir',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Ýtið á og haldið ' +
    p['keyPressed'] +
    ' og shift-lyklum. Notið síðan örvalykla til að endurraða.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Skráið heila dagsetningu eins og hér: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Skráið mánuð og ár eins og hér: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Hópur',
  chart_labelSeries: () => 'Röð',
  chart_labelValue: () => 'Gildi',
  checkboxSet_requiredMessageDetail: () => 'Áskilið',
  checkbox_requiredMessageDetail: () => 'Áskilið',
  close: () => 'Loka',
  collection_noData: () => 'Engin gögn til birtingar.',
  collection_selectAllRows: () => 'Velja allar raðir',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Velja röð ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ekki raðanlegt',
  collection_sortEnabled: () => 'Raðanlegt',
  confirmation: () => 'Staðfesting',
  datePicker_currentDate: () => 'Núverandi dags.',
  datePicker_goToToday: () => 'Fara til dags. í dag',
  datePicker_label: () => 'Dags.veljari',
  datePicker_month: () => 'Mánuður',
  datePicker_months: () => 'Mánuðir',
  datePicker_next: () => 'Næsta',
  datePicker_nextDecade: () => 'Næsti áratugur',
  datePicker_nextMonth: () => 'Næsti mánuður',
  datePicker_prev: () => 'Fyrri',
  datePicker_prevDecade: () => 'Fyrri áratugur',
  datePicker_prevMonth: () => 'Fyrri mánuður',
  datePicker_restricted: () => 'Takmarkað',
  datePicker_selected: () => 'Valið',
  datePicker_today: () => 'Í dag',
  datePicker_weekNum: (p: { NUM: string }) => 'Vika ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Vikunúmer',
  datePicker_year: () => 'Ár',
  datePicker_years: () => 'Ár',
  error: () => 'Villa',
  expandableList_expandCollapseInstructionText: () => 'Notið örvalykla til að víkka og fella saman',
  expandableList_groupCollapse: () => 'Fellt saman',
  expandableList_groupExpand: () => 'Útvíkkað',
  filePicker_addFiles: () => 'Bæta skrám við',
  filePicker_dropzonePrimaryText: () => 'Draga og sleppa',
  filePicker_dropzoneSecondaryText: () => 'Veljið skrá eða sleppið skrá hér',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Veljið eða sleppið skrám hér',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ekki er hægt að hlaða upp skrám af tegundinni ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Hlaðið einni skrá upp í einu',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ekki er hægt að hlaða upp skrám af tegundinni ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'óþekkt',
  formControl_clear: () => 'Hreinsa',
  formControl_day: () => 'Dagur',
  formControl_helpAvailable: () => 'Hjálp tiltæk',
  formControl_hide: () => 'Fela',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Þessum mörkum hefur verið náð ' +
    ((
      { one: new Intl.NumberFormat('is').format(p['CHARACTER_LIMIT']) + '-character' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('is').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('is').format(p['CHARACTER_LIMIT']) + '-character') +
    '.',
  formControl_loading: () => 'Hleður',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Hægt er að skrá allt að ' + p['MAX_LENGTH'] + ' stafi.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tákn eftir.',
  formControl_month: () => 'Mánuður',
  formControl_readOnly: () => 'Lesaðgangur',
  formControl_requiredMessageDetail: () => 'Skráið gildi.',
  formControl_show: () => 'Sýna',
  formControl_year: () => 'Ár',
  gantt_labelDate: () => 'Dags.',
  gantt_labelEnd: () => 'Endir',
  gantt_labelLabel: () => 'Merki',
  gantt_labelRow: () => 'Röð',
  gantt_labelStart: () => 'Upphaf',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Enginn eins hluti fannst.',
  indexer_keyboardInstructionText: () => 'Veljið skrá til að velja gildi',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Á milli ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Tvísmellið og haldið til að fara í strokham, dragið síðan upp og niður til að breyta gildi.',
  info: () => 'Uppl.',
  inputDateMask_date_cleared: () => 'Uppgjörsdags.',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tómt',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'áááá',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Skráið dagsetningu á eða fyrir ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Skráið dagsetningu á eða eftir ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Skráið tiltæka dagsetningu.',
  inputDatePicker_instruction: () => 'Ýtið á Tab til að komast í dagatal.',
  inputDatePicker_selectDate: () => 'Veljið dagsetningu',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Skráið mánuð og ár sem er á eða fyrir ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Skráið mánuð og ár sem er á eða eftir ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Skráið númer.',
  inputNumber_decrease: () => 'Minnka',
  inputNumber_increase: () => 'Auka',
  inputPassword_hidden: () => 'Aðgangsorð falið',
  inputPassword_hide: () => 'Fela aðgangsorð',
  inputPassword_show: () => 'Sýna aðgangsorð',
  inputSensitiveText_hidden: () => 'Viðkvæmur texti falinn',
  list_msgFetchCompleted: () => 'Hlaðið',
  list_msgFetchingData: () => 'Hleður',
  list_suggestion: () => 'Tillaga',
  messageToast_allMessagesClosed: () => 'Öllum skjáskilaboðum hefur verið lokað.',
  message_close: () => 'Loka',
  message_confirmation: () => 'Lokið',
  message_error: () => 'Villa',
  message_info: () => 'Uppl.',
  message_navigationFromMessagesRegion: () =>
    'Skráningarsvæði skilaboða. Veljið F6 til að fara til baka í fyrri þátt.',
  message_navigationToMessagesRegion: () =>
    'Ný skilaboð eru á skilaboðasvæði. Veljið F6 til að fara í síðasta skilaboðasvæði.',
  message_warning: () => 'Viðvörun',
  noData_message: () => 'Ekkert til birtingar',
  overflowItemLabel: () => 'Fleiri flipar',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Í vinnslu',
  radio_helpForRadio: () => 'Hjálp fyrir valhnapp',
  radio_requiredMessageDetail: () => 'Velja gildi.',
  selectMultiple_apply: () => 'Nota',
  selectMultiple_back: () => 'Til baka',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Notið vinstri og hægri örvalykla til að auðkenna valin gildi.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Ýtið á bakklykil eða Delete til að fjarlægja valið gildi.',
  selectMultiple_selectedValues: () => 'Valin gildi',
  selectMultiple_showSelectedValues: () => 'Sýna eingöngu valin gildi.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' gildi valin.',
  select_addToList: () => 'Bæta við lista',
  select_addToListAvailable: () => 'Bæta við lista tiltækt',
  select_moreSearchOptions: () => 'Fleiri leitarkostir',
  select_moreSearchOptionsAvailable: () => 'Fleiri leitarkostir tiltækir',
  select_noMatchesFound: () => 'Ekkert samsvarandi fannst.',
  select_oneMatchFound: () => 'Ein samsvörun fannst',
  select_requiredMessageDetail: () => 'Velja gildi.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' samsvaranir fundust',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eða fleiri samsvaranir fundust',
  selectorAll_deselectAll: () => 'Afvelja allt',
  selectorAll_selectAll: () => 'Velja allt',
  selector_selected: () => 'Hakað í hakreit',
  selector_unselected: () => 'Ekki hakað í hakreit',
  tabBarNavigationList_removeCueText: () => 'Fjarlægjanlegt',
  timeComponent_tooltipZoomIn: () => 'Þysja inn',
  timeComponent_tooltipZoomOut: () => 'Þysja út',
  train_current: () => 'Núverandi',
  train_message_type: () => 'Tegund boða',
  train_not_visited: () => 'Ekki skoðað',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Skref ' + p['currentStep'] + ' af ' + p['numberOfSteps'],
  train_visited: () => 'Skoðað',
  userAssistance_learnMore: () => 'Nánar',
  userAssistance_required: () => 'Áskilið',
  vis_clearSelection: () => 'Hreinsa val',
  vis_drillable: () => 'Kafanlegt',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' af ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Rammaval',
  vis_marqueeZoomTooltip: () => 'Rammaaðdráttur',
  vis_noData: () => 'Engin gögn til birtingar',
  vis_panTooltip: () => 'Hliðra',
  vis_stateLoaded: () => 'Hlaðið',
  vis_stateLoading: () => 'Hleður',
  vis_stateSelected: () => 'Valið',
  vis_stateUnselected: () => 'Afvalið',
  warn: () => 'Viðvörun'
};
export default bundle;
